// extracted by mini-css-extract-plugin
export var closeButton = "DoctorDetailModal-module--closeButton--8aQcE";
export var closeIcon = "DoctorDetailModal-module--closeIcon--UO4yQ";
export var detailItem = "DoctorDetailModal-module--detailItem--nOBo9";
export var detailLabel = "DoctorDetailModal-module--detailLabel--Cq1WV";
export var detailValue = "DoctorDetailModal-module--detailValue--Gn7-S";
export var divider = "DoctorDetailModal-module--divider--d9-hF";
export var doctorCredentials = "DoctorDetailModal-module--doctorCredentials--sGBIF";
export var doctorDetails = "DoctorDetailModal-module--doctorDetails--wATFu";
export var doctorImage = "DoctorDetailModal-module--doctorImage--GJJhz";
export var doctorImageSection = "DoctorDetailModal-module--doctorImageSection--ap5Z8";
export var doctorImageWrapper = "DoctorDetailModal-module--doctorImageWrapper--tbWoL";
export var doctorInfo = "DoctorDetailModal-module--doctorInfo--NcoyO";
export var doctorName = "DoctorDetailModal-module--doctorName--xuYIJ";
export var fadeIn = "DoctorDetailModal-module--fadeIn--eKIS9";
export var modalBody = "DoctorDetailModal-module--modalBody--Y7sZq";
export var modalContent = "DoctorDetailModal-module--modalContent--pUC3V";
export var modalOverlay = "DoctorDetailModal-module--modalOverlay--5IEsq";
export var slideUp = "DoctorDetailModal-module--slideUp--MuxVz";